import styled from 'styled-components';

export const PickerWrap = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;
  width: 52px;
  margin-top: 7px;
`;

export const PopupTrigger = styled.img`
  height: 16px;
  width: 16px;
  margin: 0px 8px;
`;

export const PopupContainer = styled.div`
  font-size: 13px;
  position: relative;
  max-height: 238px;
  max-width: 800px;
  background: #fff;
  width: 150px;
`;

export const PopupTitle = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  color: rgba(0, 0, 0, .7);
  font-size: 13px;
  font-weight: 600;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
  text-transform: capitalize;
  padding: 5px;
  border-bottom: 4px solid #172B4D;
  text-transform: uppercase;
`;

export const PickerList = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

export const PickerListItem = styled.div`
  display: flex;
  flex-flow: row nowrap;
  color: rgba(0, 0, 0, .7);
  font-size: 13px;
  font-weight: 600;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
  text-transform: capitalize;
  padding: 8px;
  cursor: pointer;
  background: ${props => (props.selected ? '#efefef' : '#fff')};

  &:hover {
    background: #f4f5f7;
  }
`;

export const PopupContent = styled.div`
  font-size: 13px;
  cursor: default;
  padding: 2px 0px;
  background: white;
  min-width: 132px;
  max-height: 1000px;
  border-radius: 5px;
`;

export const PopupInner = styled.div`
  flex: 1 1 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
`;
